const createHistory = require("history").createHashHistory;

export default createHistory();
